const replaceStringVariable = (name: any, value: any, string: any) =>
	string.replace(`{{${name}}}`, value);

export const getReplacedStringVariables = (
	variables: any = {},
	text: string,
) => {
	const variableNames = Object.keys(variables);

	if (variableNames?.length) {
		return variableNames.map((variableName) => {
			const variableValue = variables[variableName];

			return replaceStringVariable(variableName, variableValue, text);
		});
	}

	return text;
};

const getValueObjectTranslate = (object: any, target: any) =>
	object ? object[target] : 'Error translate not found';

export const getTranslateStringByStringKey = (
	stringKey: string,
	translates: any,
) =>
	stringKey.split('.').reduce(getValueObjectTranslate, translates) ||
	'Error translate not found';
